(function() {
  var section = document.querySelector('.lykyn-details');
  if (!section) return;
  var btns = section.querySelectorAll('.lykyn-tabs__btn');
  var panels = section.querySelectorAll('.lykyn-tabs__panel');

  btns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var tab = btn.getAttribute('data-tab');
      btns.forEach(function(b) { b.classList.remove('active'); });
      panels.forEach(function(p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var target = section.querySelector('[data-panel="' + tab + '"]');
      if (target) target.classList.add('active');
    });
  });
})();
